import pathfinder from '@fiverr-private/pathfinder';

export const buildBiEventData = (biData) => {
    const { userId, sellerId, activeGigsCount } = biData;

    return ({
        group: 'seller_page',
        user: {
            id: userId
        },
        seller: {
            id: sellerId,
            active_gigs_count: activeGigsCount
        }
    });
};

export const buildSellerCardData = ({ requestContext, userData, currency, abTests, gigs, analyticsData, isViewerStudioLead }) => {
    const { page_ctx_id: pageCtxId, current_user: currentUser } = requestContext;
    const { user, seller_card } = userData;
    const { response_time } = analyticsData;

    const userId = currentUser && currentUser.id;
    const sellerId = seller_card.user.id;
    const activeGigsCount = gigs.gigs.length;
    const biData = {
        userId,
        sellerId,
        activeGigsCount
    };

    const responseTime = response_time && response_time.value;
    const isLoggedIn = !!(currentUser && currentUser.username);

    seller_card.user.response_time = responseTime;
    seller_card.user.contact_path = pathfinder('conversation', { id: user.username });
    seller_card.user.has_live_gigs = !!activeGigsCount;
    seller_card.user.rating = seller_card.user.rating || 0;
    seller_card.user.status = user.status;

    seller_card.shouldShowReportUser = true;
    seller_card.allowEditing = false;
    seller_card.viewingAsBuyer = false;
    seller_card.isLoggedIn = isLoggedIn;
    seller_card.pageCtxId = pageCtxId;
    seller_card.currency = currency;
    seller_card.abTests = abTests;
    seller_card.isViewerStudioLead = isViewerStudioLead;

    seller_card.biEventData = buildBiEventData(biData);

    return {
        ...seller_card
    };
};

export const buildPortfolioData = (portfolioShowcase, { username = '' }) => {
    const query = { origin: 'seller_profile' };
    const link = pathfinder('user_portfolio_index', { user_id: username }, { query });
    const portfolioProjectsThumbs = portfolioShowcase.map((project) => ({ photo_url: project.item }));

    return {
        portfolioProjectsThumbs,
        link
    };
};

export const buildFiverrLearnData = (fiverrLearnCourses) =>
    fiverrLearnCourses.map((course) => ({
        ...course,
        status_updated_at: new Date(course.status_updated_at).getTime()
    }));

export const buildProSubCategories = (pro_badge = {}) => {
    const proSubCategories = pro_badge && pro_badge.pro_sub_categories;

    if (!proSubCategories) { return []; }

    return proSubCategories.map((subCat) =>
        ({ id: subCat, name: i18n.t(`sub_categories.sub_category_${subCat}.name`) })
    );
};
